import { FontWeight, Text } from '@lili/lili-frontend-common';
import { useTranslation, Trans } from 'react-i18next';
import { ReactComponent as TrustpilotIcon } from '@Assets/banners/trustpilot.svg';
import fdicImage from '@Assets/banners/fdic.png';
import { useResizeListener } from '@Hooks/custom/useResizeListener';

export const TrustpilotAndFDICSection = () => {
  const { isMobile } = useResizeListener();
  return (
    <div className='flex justify-between items-center w-full'>
      <TrustpilotIcon
        className={`w-[126px] h-[22px] object-contain ${isMobile ? 'text-text-main-primary' : 'text-text-main-primary-inverse'}`}
      />
      <img src={fdicImage} alt='FDIC' className='w-[153px] h-[34px]' />
    </div>
  );
};

export const DirectValuesProposal = () => {
  const { t } = useTranslation();
  const { isMobile } = useResizeListener();

  return (
    <div className='w-full max-w-[648px] flex flex-col justify-between items-center tab-landscape:gap-[234px] tablet:gap-[100px] gap-[66px]  px-[24px] sm:px-0 tab-landscape:pt-[37%] pt-[92px]  tab-landscape:pb-[30px] pb-[121px]'>
      {/* Main headline */}
      <Text.H6
        fontWeight={FontWeight.SEMIBOLD}
        className='max-w-[469px] w-full text-text-main-primary-inverse text-[28px] leading-[1.29] whitespace-pre-line'>
        <Trans
          t={t}
          i18nKey='pages.homePasswordless.valueProposal.mainHeadline'
          components={{
            serif: (
              <span className='font-sourceSansProSemiBold text-[32px] text-text-brand-highlight-orange' />
            ),
            orange: <span className='text-text-brand-highlight-orange' />,
          }}
        />
      </Text.H6>
      <div className='flex flex-col gap-[20px] w-full max-w-[484px]'>
        {!isMobile && <TrustpilotAndFDICSection />}

        {/* USA PATRIOT Act Notice */}
        <div className='flex flex-col w-full'>
          <div className='flex flex-col gap-[16px] pt-[16px] border-t border-outline-primary-bw-05'>
            <Text.H13 fontWeight={FontWeight.MEDIUM} className='text-text-main-primary-inverse'>
              {t('pages.homePasswordless.valueProposal.USAPatriotNotice')}
            </Text.H13>
            <Text.H14 className='text-text-main-primary-inverse'>
              {t('pages.homePasswordless.valueProposal.USAPatriotNoticeContent')}
            </Text.H14>
          </div>
        </div>
      </div>
    </div>
  );
};
